function serchBarclass() {
    const input = document.querySelector('input[type="search"]');
    const form = document.querySelector('form[role="search"]');
    const resetBtn = form.querySelector('button[type="reset"]');

    input.addEventListener("input", function() {
        if (input.value.trim() !== "") {
            form.classList.add("searching");
        } else {
            form.classList.remove("searching");
        }
    });

    resetBtn.addEventListener("click", function() {
        setTimeout(() => {
            form.classList.remove("searching");
        }, 0);
    });
}


serchBarclass();

function VideoHeading() {
    const heading = document.getElementById('animated-heading');
    if (!heading) return;
    const rawText = heading.dataset.sentences || '';
    const sentences = rawText
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);

    if (sentences.length === 0) return;

    let index = 0;

function showNextSentence(){
    heading.classList.remove('visible');

    setTimeout(() => {
        heading.textContent = sentences[index];
        heading.classList.add('visible');
        index = (index + 1) % sentences.length;
    }, 500);

  }
    heading.textContent = sentences[0];
    heading.classList.add('visible');
    index = 1;
    setInterval(showNextSentence, 3000);
}

function MobileMenu() {
    const detailsMenu = document.querySelector('.mobile-menu');
    const hamburgerIcon = detailsMenu.querySelector('.icon-hamburger');
    const closeIcon = detailsMenu.querySelector('.icon-close');

    if (!detailsMenu || !hamburgerIcon || !closeIcon) return;

    function updateIcons() {
        const isOpen = detailsMenu.hasAttribute('open');
        hamburgerIcon.classList.toggle('hidden', isOpen);
        closeIcon.classList.toggle('hidden', !isOpen);
    }

    detailsMenu.addEventListener('toggle', updateIcons);
}

function FadeInheading() {
    const container = document.getElementById('animated-text-container');
    if(container){
    const lines = container.querySelectorAll('.animated-line');

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    lines.forEach((line, index) => {
                        line.style.setProperty('--delay', `${index * 0.5}s`);
                        line.classList.remove('visible');
                        void line.offsetWidth;
                        setTimeout(() => {
                            line.classList.add('visible');
                        }, 10);
                    });
                } else {
                    lines.forEach((line) => {
                        line.classList.remove('visible');
                    });
                }
            });
        }, {
            threshold: 0.5
        }
    );

    observer.observe(container);
}
}
function getHeight() {
  if (window.innerWidth >= 1000) {
    const proHeight = document.querySelector('.product-gallery__media-list')?.offsetHeight || 0;
    const target = document.querySelector('.product-gallery__thumbnail-arrows .product-gallery__thumbnail-list');
    if (target) {
      target.style.maxHeight = proHeight + 'px';
    }
  } else {
    // Reset when under 1000px if needed
    const target = document.querySelector('.product-gallery__thumbnail-arrows .product-gallery__thumbnail-list');
    if (target) {
      target.style.maxHeight = '';
    }
  }
}
function img_content_head_width() {
  // get all headings inside the section
  var headings = document.querySelectorAll(
    ".image-content-section .content-full_width .sheading"
  );

  headings?.forEach(function(heading) {
    var shead_width = heading.offsetWidth; // width of the heading
    var sectionDesc = heading.parentElement.querySelector(".section_desc"); // find .section_desc in the same parent

    if (sectionDesc) {
      sectionDesc.style.maxWidth = shead_width + "px";
    }
  });
}



// run on resize
window.addEventListener("resize", img_content_head_width);


// Run on resize
window.addEventListener('resize', getHeight);

document.addEventListener('DOMContentLoaded', function() {
   VideoHeading();
    MobileMenu();
    FadeInheading();
getHeight();
img_content_head_width();

});
  